import React from "react";
import ContactGroupEditor from "./ContactGroupEditor";
import { triggerStyles } from "../../common/styles";
import Modal from "../../common/components/Modal";

class ContactGroupEditorLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showEditor: false };

        this._toggleShowEditor = this._toggleShowEditor.bind(this);
    }

    render() {
        const linkText = this.props.contactGroupId ? "edit" : "New Group";
        
        return (
            <div style={ this.props.style }>
                <span className="x-new-group-trigger"
                      style={ Object.assign({}, triggerStyles(this.state.showEditor), {marginLeft: 7}) }
                      onClick={ this._toggleShowEditor }>{linkText}</span>
                { this.state.showEditor 
                    ? <Modal onClose={() => this.setState({showEditor: false})}>
                          <ContactGroupEditor onComplete={this._toggleShowEditor} 
                                              contactGroupId={this.props.contactGroupId}/>
                      </Modal>
                    : null}
            </div>
        );
    }

    _toggleShowEditor() {
        this.setState({ showEditor: !this.state.showEditor });
    }
}
ContactGroupEditorLink.propTypes = {
    contactGroupId: React.PropTypes.string,
    style: React.PropTypes.object
};

export default ContactGroupEditorLink;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/components/ContactGroupEditorLink.js
 **/